import React from 'react';
import { forklift } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Boat storage',
  synonyms: 'yard boat yard boatyard',
  group: 'standardMarker',
  typeUrl: 'boat-storage',
  icon: {
    baseShape: forklift,
    iconColor: '#fff',
    markerColor: '#56AC5C',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-facilities',
    order: 5,
  },
  standardMarkerOptions: {
    markerType: 'boatStorageMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Boat storage',
      itemTitleFunction: (item) => (item && item.title) || 'Boat storage',
    },
    creationOptions: {
      menuText: 'Boat storage',
      newTitle: 'Boat storage',
      titlePlaceholder: 'Name of boat storage',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker indicates a boat storage or winterising location.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Boat storage',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
